module.exports = __webpack_public_path__ + "img/img16s.377ff39a.png";